import { render, staticRenderFns } from "./ClientDeleteModal.vue?vue&type=template&id=74f6b2b8&scoped=true&"
import script from "./ClientDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ClientDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientDeleteModal.vue?vue&type=style&index=0&id=74f6b2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f6b2b8",
  null
  
)

export default component.exports